import { ref, computed, isRef, onUpdated } from "vue";
import { isAxiosError } from "axios";
import { make } from "simple-body-validator";

/**
 * Helper para crear un validador.
 * @param {Ref<object> | object} dataObject La data reactiva a cambiar o solo la data inicial.
 * @param {object} rules .Reglas adicionales para usar en la validación del front.
 * @returns
 */
export const makeValidator = (dataObject, rules) => {
  const data = isRef(dataObject) ? dataObject : ref(dataObject);

  const validator = ref(make(data.value, rules));

  const errors = computed(() => validator.value.errors());

  const setErrors = (newErrors) => {
    if (isAxiosError(newErrors)) {
      validator.value.setErrors(
        newErrors.response?.data?.error?.details?.validation
      );
    }
  };

  const validate = () => validator.value.validate();

  // Esto es para que se actualice el validator cuando  cambie el componente
  onUpdated(() => {
    if (validator.value.data !== data.value)
      validator.value = make(data.value, rules);
  });

  return { validator, validate, errors, setErrors };
};
